import { apiClient, API_ENDPOINTS, TIME_BUDGETS } from '../../../lib';
import type { CreateSiteFromTemplateRequest, SetupModalystProductsRequest } from '@common/api-types';
import type { CreateMetaSiteFromTemplateResponse } from '@wix/ambassador-metasite-api-v1-meta-site/types';

export async function updateTheme(metaSiteId: string, themeKey?: string): Promise<void> {
  await apiClient.post(
    API_ENDPOINTS.site.updateTheme,
    {
      metaSiteId,
      themeKey,
    },
    {
      headers: { 'x-time-budget': `${TIME_BUDGETS.extended}` },
    },
  );
}

export async function createSiteFromTemplate(category: string): Promise<string> {
  const request: CreateSiteFromTemplateRequest = { category };

  const response = await apiClient.post<CreateMetaSiteFromTemplateResponse>(
    API_ENDPOINTS.site.createFromTemplate,
    request,
    {
      headers: { 'x-time-budget': `${TIME_BUDGETS.extended}` },
    },
  );

  return response.metaSite?.metaSiteId || '';
}

export async function setupModalystProducts(metaSiteId: string, productList: string[]): Promise<void> {
  const request: SetupModalystProductsRequest = {
    productList,
    metaSiteId,
  };

  await apiClient.post(API_ENDPOINTS.storeSetup.setupModalystProducts, request, {
    headers: { 'x-time-budget': `${TIME_BUDGETS.long}` },
  });
}
